/* eslint-disable @typescript-eslint/no-extraneous-class */
import { NgModule } from '@angular/core';
import { MssLibModule } from 'msslib';

@NgModule({
  imports: [MssLibModule],
})
export class AppLibModule {}

export * from './constants';
export * from './models';
export * from './services';
export * from './test';
